module.exports = __webpack_public_path__ + "img/nuki-box-md.da333ab1.svg";